module.exports = __webpack_public_path__ + "media/images/team/jon_wyeth-5ab391fb0e6b5b21a82aa277152c7d84.png";